module.exports = __webpack_public_path__ + "media/flags/pt-4082bfb9.svg";